<div class="dialog course-instructor-wrapper">
  @if (isOpenedInDialog) {
    @if (isMobileView()) {
      <div class="mobile-app-bar right-action-icons-only sticky-header">
        <h2 class="mobile-app-bar__heading">{{ 'Room Details' | translate }}</h2>
        @if ((isUserAdmin || isUserCreator) && !isLoading) {
          <div class="mobile-app-bar__action-icon">
            <app-icon (click)="editRoom()" iconName="pencil" size="16px"></app-icon>
          </div>
          <div class="mobile-app-bar__action-icon">
            <app-icon (click)="deleteRoom(this.currentRoom)" iconName="trash" size="16px"></app-icon>
          </div>
        }
        <div class="mobile-app-bar__action-icon">
          <app-icon (click)="close()" iconName="close" size="16px"></app-icon>
        </div>
      </div>
    } @else {
      <header class="dialog__header">
        <h3 class="dialog__header__title">{{ 'Room Details' | translate }}</h3>
        <div class="dialog__header__action-buttons">
          @if ((isUserAdmin || isUserCreator) && !isLoading) {
            <div class="dialog__header__action-buttons__button">
              <span>
                <app-icon (click)="editRoom()" [cssStyle]="{ margin: '4px' }" iconName="pencil" size="20px"></app-icon>
              </span>
            </div>
            <div class="dialog__header__action-buttons__button">
              <span>
                <app-icon (click)="deleteRoom(this.currentRoom)" [cssStyle]="{ margin: '4px' }" iconName="trash-bin" size="20px"></app-icon>
              </span>
            </div>
          }
          <div class="dialog__header__action-buttons__button">
            <span>
              <app-icon (click)="close()" [cssStyle]="{ margin: '4px' }" iconName="close" size="20px"></app-icon>
            </span>
          </div>
        </div>
      </header>
    }
  }

  @if (!isLoading && currentRoom) {
    <!--  @if (false) {-->

    @if (!isLoading && currentRoom.name && alertType) {
      <div [class]="{ 'px-16': isMobileView }">
        <app-alert-message [alertType]="alertType" [denyReason]="currentRoom?.denyReason" [showCloseIcon]="false" size="small" marginTop="20px"></app-alert-message>
      </div>
    }

    <div [class.--detail-view]="isOpenedInDialog" class="instructor-header">
      <div class="image-wrapper background-loading">
        <img [src]="currentRoom.imageUrl" alt="" appDefaultImage="assets/images/defaults/room.png" lazy="true" loading="lazy" />
      </div>
      <div class="instructor">
        <h2 class="instructor__name">{{ currentRoom.name }}</h2>
        <p [innerHTML]="currentRoom.description" class="instructor__description">
          {{ currentRoom.description }}
        </p>
      </div>
    </div>

    @if (doesHaveEmail || doesHavePhoneNumber) {
      <div class="instructor-details border-lines">
        @if (doesHavePhoneNumber) {
          <div class="flex-row-start-center gap-6">
            <div class="gray-circle">
              <app-icon color="var(--white)" iconName="chat" size="18px"></app-icon>
            </div>
            <div>
              <label class="instructor-details__label" translate>Phone</label>
              <p class="instructor-details__text">{{ currentRoom.phoneNo }}</p>
            </div>
          </div>
        }
        @if (doesHaveEmail) {
          <div class="flex-row-start-center gap-6">
            <div class="gray-circle">
              <app-icon color="var(--white)" iconName="envelope" size="18px"></app-icon>
            </div>
            <div>
              <label class="instructor-details__label" translate>&#64;-Mail</label>
              <p class="instructor-details__text">{{ currentRoom.email }}</p>
            </div>
          </div>
        }
        <!--      <div class="flex-row-start-center gap-6">-->
        <!--        <div class="gray-circle">-->
        <!--          <app-icon color="var(&#45;&#45;white)" iconName="globe" size="18px"></app-icon>-->
        <!--        </div>-->
        <!--        <div>-->
        <!--          <label class="instructor-details__label" translate>Web</label>-->
        <!--          <p class="instructor-details__text">www.google.com</p>-->
        <!--        </div>-->
        <!--      </div>-->
      </div>
    }

    <div class="about-instructor">
      <app-dynamic-tabs>
        <!--        <ng-template [tabName]="'Available Times' | translate">-->
        <!--          <div class="schedule">-->
        <!--            <ul>-->
        <!--              @for (item of roomAvailability; track item.name + item.time) {-->
        <!--                <li>-->
        <!--                  <span>{{ item.name }}</span>-->
        <!--                  <span>{{ item.time }} {{ 'Clock' | translate }}</span>-->
        <!--                </li>-->
        <!--              }-->
        <!--            </ul>-->
        <!--          </div>-->
        <!--        </ng-template>-->

        <ng-template [tabName]="'Available Times' | translate">
          <div class="schedule">
            <ul>
              @for (item of roomAvailability; let i = $index; track item.name + item.time) {
                <li>
                  @if (i === 0 || item.name !== roomAvailability[i - 1].name) {
                    <span>{{ item.name }}</span>
                  } @else {
                    <i class="--empty">&nbsp;</i>
                  }
                  <span>{{ item.time }} {{ 'Clock' | translate }}</span>
                </li>
              }
            </ul>
          </div>
        </ng-template>

        <!--      <ng-template [tabName]="'Theme' | translate">-->
        <!--        <div class="schedule">-->
        <!--          <p translate>No Theme</p>-->
        <!--        </div>-->
        <!--      </ng-template>-->

        <ng-template [tabName]="'Room Details' | translate">
          <div class="schedule">
            <ul>
              <li>
                <span translate>Address</span>
                <span>{{ currentRoom.address }}</span>
              </li>
            </ul>
          </div>
          <div class="schedule">
            <ul>
              <li>
                <span translate>People</span>
                <span>{{ currentRoom.noOfPersons }} {{ 'People' | translate }}</span>
              </li>
            </ul>
          </div>
          @if (currentRoom.price) {
            <div class="schedule">
              <ul>
                <li>
                  <span translate>Price</span>
                  <span>€ {{ currentRoom.price }}</span>
                </li>
              </ul>
            </div>
          }
        </ng-template>
      </app-dynamic-tabs>
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="loader"></ng-container>
  }
</div>

<ng-template #loader>
  @if (isOpenedInDialog) {
    <div class="p-16">
      <ngx-skeleton-loader [theme]="{ height: '250px', borderRadius: '8px' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{ height: '50px', borderRadius: '8px', marginTop: '10px' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{ height: '100px', borderRadius: '8px', marginTop: '10px' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{ height: '50px', borderRadius: '8px', marginTop: '10px' }" count="2"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{ height: '120px', borderRadius: '8px', marginTop: '10px' }"></ngx-skeleton-loader>
    </div>
  } @else {
    <div>
      <ngx-skeleton-loader [theme]="{ height: '180px', width: '180px', margin: '16px' }" appearance="circle"></ngx-skeleton-loader>
    </div>
    <div>
      <ngx-skeleton-loader [theme]="{ height: '60px' }"></ngx-skeleton-loader>
    </div>
    <div>
      <ngx-skeleton-loader [theme]="{ height: '150px' }"></ngx-skeleton-loader>
    </div>
  }
</ng-template>
